import styled from "styled-components";

export const Container = styled.div`
  width: 1300px;
  margin: 0 auto;
  padding-top: 40px;
  @media (max-width: 780px) {
    width: 90%;
  }
`;
